import axios from 'axios'
import { i18n } from '../../plugins/i18n'

export const companiesAccountSetting = {
  namespaced: true,
  state: {
    data: {
      last_name: '',
      first_name: '',
      email: '',
    },
    meta: {
      pending_reconfirmation: false,
    },
    loading: false,
    loadError: false,
    writeError: false,
  },
  mutations: {
    apiConnect(state) {
      state.loading = true
      state.loadError = false
    },
    readAccountSetting(state, payload) {
      state.data = {
        last_name: payload.data.attributes.last_name,
        first_name: payload.data.attributes.first_name,
        email: payload.data.attributes.email,
      }
      state.meta = {
        pending_reconfirmation: payload.meta.pending_reconfirmation,
      }
      state.loading = false
    },
    writeAccountSetting(state, payload) {
      state.data = {
        last_name: payload.data.attributes.last_name,
        first_name: payload.data.attributes.first_name,
        email: payload.data.attributes.email,
      }
      state.meta = {
        pending_reconfirmation: payload.meta.pending_reconfirmation,
      }
      state.loading = false
      state.writeError = false
    },
    getErrorResponse(state) {
      state.loading = false
      state.loadError = true
    },
    writeErrorResponse(state) {
      state.loading = false
      state.writeError = true
    },
  },
  actions: {
    readAccountSetting({ commit }, companyUuid) {
      commit('apiConnect')
      return axios
        .get('/api/companies/' + companyUuid + '/account_setting.json')
        .then(res => {
          commit('readAccountSetting', res.data)
        })
        .catch(err => {
          commit('getErrorResponse', err)
          console.error(err)
        })
    },
    writeAccountSetting({ commit, state }, { companyUuid, payload }) {
      if (state.loading) return
      commit('flash/clearFlash', null, { root: true })
      commit('apiConnect')
      return axios
        .patch('/api/companies/'+ companyUuid +'/account_setting.json', payload)
        .then(res => {
          commit('writeAccountSetting', res.data)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updatedInfo', { value: i18n.t('models.user.account') }) }, { root: true })
        })
        .catch(err => {
          commit('writeErrorResponse')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    }
  }
}
